import { render, staticRenderFns } from "./order-arrangement-by-renter.vue?vue&type=template&id=3bc97206&scoped=true&lang=pug&"
import script from "./order-arrangement-by-renter.vue?vue&type=script&lang=js&"
export * from "./order-arrangement-by-renter.vue?vue&type=script&lang=js&"
import style0 from "./order-arrangement-by-renter.vue?vue&type=style&index=0&id=3bc97206&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc97206",
  null
  
)

export default component.exports